import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import ClampLines from 'react-clamp-lines';

import ArticleActions from 'component/shared/article/actions.component';
import articleImage from 'resource/img/article-default.jpg';
import UserOwner from 'component/shared/article/userOwner.component';
import './article.item.component.css';

class ArticleItem extends PureComponent {
  _classFlex() {
    const { reverse } = this.props;
    return reverse ? 'flex-row-reverse' : 'flex-row';
  }

  _openArticleDetails = () => {
    const { slug } = this.props.article;
    this.props.resetArticleComments();

    this.props.history.push(`/artigos/${slug}`, {
      article: this.props.article,
    });
  };

  constructor() {
    super();
    this.state = {
      image: '',
      title: '',
      summary: '',
      user: {},
      updated_at: '',
      created_at: '',
      like_count: 0,
      dislike_count: 0,
      comments: [],
    };
  }

  componentDidMount() {
    this.setState({
      ...this.props.article,
      user: this.props.article.user_edited,
    });
  }

  static getDerivedStateFromProps(props, state) {
    return props.article;
  }

  render() {
    const {
      image,
      title,
      summary,
      user_edited: user,
      created_at,
      like_count,
      dislike_count,
      comments,
    } = this.state;
    return (
      <section
        className={`${this._classFlex()} justify-center align-center article-item-container`}
      >
        <div
          className="article-image-container"
          onClick={this._openArticleDetails}
        >
          <img
            src={image ? image : articleImage}
            className="article-item-image"
            alt="Imagem do artigo"
          />
        </div>
        <div className="article-item-content flex-column justify-center ">
          <UserOwner user={user ? user : {}} created_at={created_at} />
          <div onClick={this._openArticleDetails}>
            <h4 className="article-item-title">{title}</h4>
            <ClampLines
              text={summary}
              id="article-1"
              lines={4}
              buttons={false}
              className="article-item-summary"
            />
          </div>
          <div className="flex-row flex-1 justify-between m-1">
            <ArticleActions
              like_count={like_count}
              dislike_count={dislike_count}
              comments={comments}
              article={this.props.article}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(ArticleItem);
